<template>
    <div>
        <div>
            <h3 class="hd">
                表头信息
                <Button class="fr batch" type="text" @click="batchShowFn"
                    >批量设置</Button
                >
            </h3>
            <div :style="{ minHeight: leftHeight }" id="wrapper">
                <div class="scrollChild" ref="scrollChild" id="wrapperChild">
                    <div v-for="(name, index) in msg.data" :key="index">
                        <p style="background:#f69">{{ index }}</p>
                        <div v-for="(nameArr, nameIndex) in name">
                            <div v-for="(item, itemIndex) in nameArr">
                                <p style="background:#ccc">{{ itemIndex }}</p>
                                <Table
                                    @on-selection-change="
                                        batchChange(
                                            $event,
                                            index,
                                            nameIndex,
                                            itemIndex
                                        )
                                    "
                                    border
                                    ref="selection"
                                    :columns="columns"
                                    :data="item"
                                ></Table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="答案设置"
            @close="dialogClose"
            :close-on-click-modal="false"
            :visible.sync="setShow"
        >
            <div class="mask_box">
                <div class="clearfix mod mod_btn">
                    <span class="fl">选择模板</span>
                    <div class="fl">
                        <Button
                            v-for="(btn, index) in modBtn"
                            :class="[{ active: setItem.type == index }]"
                            :key="btn"
                            @click="setModBtn(index)"
                            >{{ btn }}</Button
                        >
                    </div>
                </div>
                <div
                    class="clearfix mod"
                    v-show="
                        setItem.type != 0 &&
                            setItem.type != 3 &&
                            setItem.type != 4
                    "
                >
                    <span class="fl">设置选项</span>
                    <div class="fl inpBox">
                        <div>
                            <ul>
                                <li
                                    class="clearfix"
                                    v-for="(val, index) in setItem.btnData"
                                >
                                    <a
                                        href="javascript:;"
                                        class="fl"
                                        v-show="setItem.type != 1"
                                        @click="removeInpFn(index)"
                                        ><Icon type="close-circled"></Icon
                                    ></a>
                                    <Input
                                        type="text"
                                        class="fr"
                                        v-model="setItem.btnData[index]"
                                    ></Input>
                                </li>
                            </ul>
                            <a
                                href="javascript:;"
                                v-show="setItem.type != 1"
                                @click="addInpFn"
                                >添加选项</a
                            >
                        </div>
                    </div>
                </div>
                <div class="clearfix mod" v-show="setItem.type == 0">
                    <span class="fl">设置长度</span>
                    <div class="fl inpBox">
                        <InputNumber v-model="setItem.len"></InputNumber>
                    </div>
                </div>
                <div class="clearfix mod" v-show="setItem.type == 0">
                    <span class="fl">正则限制</span>
                    <div class="fl inpBox">
                        <Select v-model="setItem.reg" width="100%">
                            <Option
                                v-for="item in selData"
                                :key="item.val"
                                :value="item.val"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </div>
                </div>
                <div class="clearfix mod">
                    <span class="fl">备注</span>
                    <div class="fl inpBox">
                        <Input type="text" v-model="setItem.remarks"></Input>
                    </div>
                </div>
                <div class="clearfix mod">
                    <span class="fl">说明文字</span>
                    <div class="fl inpBox">
                        <Input
                            type="text"
                            v-model="setItem.explain_txt"
                        ></Input>
                    </div>
                </div>
                <div class="clearfix mod">
                    <span class="fl">说明图片</span>
                    <div class="fl clearfix">
                        <div
                            class="demo-upload-list fl"
                            v-for="(item, index) in setItem.explain_img"
                            :key="index"
                        >
                            <img :src="item" />
                            <div class="demo-upload-list-cover">
                                <Icon
                                    type="ios-eye-outline"
                                    @click.native="handleView(item)"
                                ></Icon>
                                <Icon
                                    type="ios-trash-outline"
                                    @click.native="handleRemove(item)"
                                ></Icon>
                            </div>
                        </div>
                        <button
                            class="demo-upload-list fl"
                            @click="inputChange"
                        >
                            <div
                                style="width: 58px;height:58px;line-height: 58px;"
                            >
                                <Icon type="camera" size="20"></Icon>
                            </div>
                        </button>
                        <input
                            type="file"
                            @change="handleFileChange"
                            style="display:none"
                            ref="inputer"
                        />
                        <Modal title="图片预览" v-model="visible">
                            <img :src="visibleImg" style="width: 100%" />
                        </Modal>
                    </div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <Button @click="setShow = false">取 消</Button>
                <Button @click="setAnswerFn" type="primary">确 定</Button>
            </div>
        </el-dialog>
        <el-dialog title="修改表头" :visible.sync="modifyShow">
            <Form
                ref="tableHd"
                :model="tableItem"
                :rules="formValidate"
                :label-width="100"
            >
                <Form-item label="表头名称" prop="td">
                    <Input
                        type="text"
                        v-model="tableItem.td"
                        placeholder="请输入..."
                    ></Input>
                </Form-item>
            </Form>
            <div slot="footer" class="dialog-footer">
                <Button @click="modifyShow = false">取 消</Button>
                <Button @click="tableHdFn" type="primary">确 定</Button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["msg"],
    data() {
        return {
            leftHeight: null,
            myScroll: null,
            tableItem: {
                td: "",
                btnIndex: ""
            },
            setItem: {
                td: null,
                type: 4,
                len: null,
                reg: 0,
                remarks: null,
                btnIndex: null,
                tabIndex: null,
                btnName: "未设置",
                btnData: ["", ""],
                colname: "",
                ruleID: "",
                explain_txt: "",
                explain_img: []
            },
            visibleImg: "",
            visible: false,
            setType: "",
            setShow: false,
            modifyShow: false,
            modBtn: ["输入框", "Y/N模板", "自定义模板", "图片链接"],
            selData: [
                {
                    name: "-请选择-",
                    val: 0
                },
                {
                    name: "必填项且大于等于0，若小数则小数点后保留两位",
                    val: 1
                },
                {
                    name: "必填项且1或0",
                    val: 2
                },
                {
                    name: "必填项且文本",
                    val: 3
                },
                {
                    name: "必填项且正整数",
                    val: 4
                },
                {
                    name:
                        "非必填项，若填写，则需大于等于0，若小数则小数点后保留两位",
                    val: 5
                },
                {
                    name: "非必填项，若填写，则需1或0",
                    val: 6
                },
                {
                    name: "非必填项，若填写，则需文本",
                    val: 7
                },
                {
                    name: "非必填项，若填写，则需正整数",
                    val: 8
                },
                {
                    name:
                        "非必填项，若填写，则需大于等于0，若小数则小数点后保留一位",
                    val: 9
                },
                {
                    name: "必填项且大于等于0，若小数则小数点后保留一位",
                    val: 10
                }
            ],
            formValidate: {
                td: [
                    {
                        required: true,
                        message: "表头名称不能为空",
                        trigger: "change"
                    }
                ]
            },
            columns: [
                //批量设置答案弹出层table表头
                {
                    type: "selection",
                    width: 60,
                    align: "center"
                },
                {
                    title: "表头信息",
                    key: "td"
                },
                {
                    title: "问题类型",
                    key: "btnName"
                },
                {
                    title: "输入长度",
                    key: "len"
                },
                {
                    title: "备注",
                    key: "remarks"
                },
                {
                    title: "正则限制",
                    key: "reg",
                    render: (h, params) => {
                        return h("p", this.selData[params.row.reg].name);
                    }
                },
                {
                    title: "操作",
                    width: 220,
                    render: (h, params) => {
                        return h("div", [
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "text",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            this.setItem = JSON.parse(
                                                JSON.stringify(params.row)
                                            );
                                            this.setType = 1;
                                            this.setShow = true;
                                        }
                                    }
                                },
                                "答案设置"
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "text",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            this.tableItem.td = params.row.td;
                                            this.tableItem.boxIndex =
                                                params.row.boxIndex;
                                            this.tableItem.navIndex =
                                                params.row.navIndex;
                                            this.tableItem.tabIndex =
                                                params.row.tabIndex;
                                            this.tableItem.btnIndex =
                                                params.row.btnIndex;
                                            this.modifyShow = true;
                                        }
                                    }
                                },
                                "修改表头"
                            ),
                            h(
                                "Button",
                                {
                                    props: {
                                        type: "text",
                                        size: "small"
                                    },
                                    on: {
                                        click: () => {
                                            var _this = this;
                                            this.$Modal.confirm({
                                                content: "确定要删除本行吗？",
                                                onOk() {
                                                    _this.msg.data[
                                                        params.row.boxIndex
                                                    ][params.row.navIndex][
                                                        params.row.tabIndex
                                                    ].splice(params.index, 1);
                                                }
                                            });
                                        }
                                    }
                                },
                                "删除"
                            )
                        ]);
                    }
                }
            ]
        };
    },
    mounted() {
        this.leftHeightFn();
        window.addEventListener("resize", this.leftHeightFn);
        setTimeout(() => {
            this.myScroll = new IScroll("#wrapper", {
                scrollbars: true,
                mouseWheel: true,
                interactiveScrollbars: true,
                shrinkScrollbars: "scale",
                fadeScrollbars: false,
                preventDefault: false
            });
        }, 200);
    },
    methods: {
        leftHeightFn() {
            //可视区高度改变
            var H =
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            this.$refs.scrollChild.style.height = this.$refs.scrollChild.offsetHeight;
            this.leftHeight = H - 300 + "px";
        },
        handleRemove(item) {
            this.setItem.explain_img.splice(
                this.setItem.explain_img.indexOf(item),
                1
            );
        },
        handleView(url) {
            this.visibleImg = url;
            this.visible = true;
        },
        inputChange() {
            if (this.setItem.explain_img.length > 19) {
                this.$Notice.warning({
                    title: "上传图片失败",
                    desc: "图片最多上传20张"
                });
                return false;
            }
            this.$refs.inputer.click();
        },
        imgPreview(file) {
            var self = this;
            // 创建一个reader
            var reader = new FileReader();
            // 将图片将转成 base64 格式
            reader.readAsDataURL(file);
            // 读取成功后的回调
            reader.onloadend = function() {
                var resss = this.result;
                self.$http
                    .post("/web/img/uploadimg", {
                        baseimg: resss
                    })
                    .then(function(res) {
                        self.setItem.explain_img.push(res.url);
                    })
                    .catch(function(res) {
                        self.$Message.error("图片上传失败");
                    });
            };
        },
        handleFileChange() {
            let inputDOM = this.$refs.inputer;
            if (!inputDOM["value"].match(/.jpg|.jpeg|.png/i)) {
                //判断上传文件格式
                this.$Notice.warning({
                    title: "上传图片失败",
                    desc: "图片格式不对，请上传jpg,png格式"
                });
                return false;
            }
            this.file = inputDOM.files[0];
            if (this.file) {
                if (this.file.size < 2097152) {
                    this.imgPreview(this.file);
                } else {
                    this.$Notice.warning({
                        title: "上传图片失败",
                        desc: "图片过大，请上传2MB以内的图片"
                    });
                }
            }
        },
        tableHdFn() {
            this.$refs.tableHd.validate(valid => {
                if (valid) {
                    var _this = this;
                    this.msg.data[this.tableItem.boxIndex][
                        this.tableItem.navIndex
                    ][this.tableItem.tabIndex].forEach(function(i) {
                        if (i.btnIndex == _this.tableItem.btnIndex) {
                            i.td = _this.tableItem.td;
                        }
                    });
                    this.modifyShow = false;
                } else {
                    this.$Message.error("表单验证失败!");
                }
            });
        },
        batchChange(e, boxIndex, navIndex, tabIndex) {
            var arr = [];
            for (var i = 0; i < e.length; i++) {
                arr.push(e[i].btnIndex);
            }
            this.msg.batch[boxIndex][navIndex][tabIndex] = arr;
        },
        batchShowFn() {
            var bFlag = 0;
            var jsonLen = 0;
            for (let name in this.msg.batch) {
                for (let i = 0; i < this.msg.batch[name].length; i++) {
                    for (let item in this.msg.batch[name][i]) {
                        jsonLen++;
                        if (!this.msg.batch[name][i][item].length) {
                            bFlag++;
                        }
                    }
                }
            }
            if (bFlag == jsonLen) {
                this.$Notice.warning({
                    title: "答案设置",
                    desc: "还没有勾选"
                });
            } else {
                this.setType = 2;
                this.setItem.remarks = null;
                this.setItem.reg = 0;
                this.setItem.btnData = ["", ""];
                this.setItem.len = null;
                this.setItem.type = 4;
                this.setShow = true;

                this.setItem.explain_txt = "";
                this.setItem.explain_img = [];
            }
        },
        setAnswerFn() {
            var bFlag = true;
            if (this.setItem.type == 4) {
                this.$Notice.warning({
                    title: "答案设置",
                    desc: "请选择模板"
                });
                return false;
            }
            if (this.setItem.type != 0 && this.setItem.type != 3) {
                var len = 0;
                for (var i = 0; i < this.setItem.btnData.length; i++) {
                    if (!this.setItem.btnData[i]) {
                        bFlag = false;
                    } else if (this.setItem.btnData[i].length > len) {
                        len = this.setItem.btnData[i].length;
                    }
                }
                if (bFlag) {
                    this.setItem.len = len;
                } else {
                    this.$Notice.warning({
                        title: "答案设置",
                        desc: "选项不能为空"
                    });
                }
            }
            if (this.setItem.type == 0 && !this.setItem.len) {
                this.$Notice.warning({
                    title: "答案设置",
                    desc: "长度不能为空"
                });
                bFlag = false;
            }
            if (bFlag) {
                if (this.setType == 1) {
                    for (
                        let i = 0;
                        i <
                        this.msg.data[this.setItem.boxIndex][
                            this.setItem.navIndex
                        ][this.setItem.tabIndex].length;
                        i++
                    ) {
                        if (
                            this.msg.data[this.setItem.boxIndex][
                                this.setItem.navIndex
                            ][this.setItem.tabIndex][i].btnIndex ==
                            this.setItem.btnIndex
                        ) {
                            this.$set(
                                this.msg.data[this.setItem.boxIndex][
                                    this.setItem.navIndex
                                ][this.setItem.tabIndex],
                                i,
                                this.setItem
                            );
                        }
                    }
                } else {
                    for (let name in this.msg.batch) {
                        for (let i = 0; i < this.msg.batch[name].length; i++) {
                            for (let item in this.msg.batch[name][i]) {
                                for (
                                    let j = 0;
                                    j < this.msg.batch[name][i][item].length;
                                    j++
                                ) {
                                    for (
                                        let n = 0;
                                        n < this.msg.data[name][i][item].length;
                                        n++
                                    ) {
                                        if (
                                            this.msg.data[name][i][item][n]
                                                .btnIndex ==
                                            this.msg.batch[name][i][item][j]
                                        ) {
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "type",
                                                this.setItem.type
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "len",
                                                this.setItem.len
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "reg",
                                                this.setItem.reg
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "remarks",
                                                this.setItem.remarks
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "btnName",
                                                this.setItem.btnName
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "btnData",
                                                this.setItem.btnData
                                            );

                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "explain_txt",
                                                this.setItem.explain_txt
                                            );
                                            this.$set(
                                                this.msg.data[name][i][item][n],
                                                "explain_img",
                                                this.setItem.explain_img
                                            );
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.msg.batch = JSON.parse(JSON.stringify(this.msg.init));
                }
                this.setShow = false;
            }
        },
        setModBtn(index) {
            //点击模板按钮
            this.setItem.remarks = null; //初始化备注
            this.setItem.reg = 0;
            if (index == 1) {
                //当按钮是Y/N模板时
                this.setItem.btnData = ["Y", "N"];
            } else {
                this.setItem.btnData = ["", ""];
            }
            if (index == 3) {
                //当按钮是图片链接模板时
                this.setItem.len = 100;
            } else {
                this.setItem.len = null;
            }
            this.setItem.btnName = this.modBtn[index];
            this.setItem.type = index; //设置按钮类型坐标
        },
        removeInpFn(index) {
            if (this.setItem.btnData.length <= 2) {
                this.$Notice.warning({
                    title: "删除选项",
                    desc: "选项不能少于两个"
                });
            } else {
                this.setItem.btnData.splice(index, 1);
            }
        },
        addInpFn() {
            if (this.setItem.btnData.length >= 100) {
                this.$Notice.warning({
                    title: "添加选项",
                    desc: "不能再添加了"
                });
            } else {
                this.setItem.btnData.push("");
            }
        },
        dialogClose() {
            //关闭弹出框清理数据
            if (this.setType == 1) {
                this.setItem = {
                    td: null,
                    type: 4,
                    len: null,
                    reg: 0,
                    remarks: null,
                    btnIndex: null,
                    tabIndex: null,
                    btnName: "未设置",
                    btnData: ["", ""],
                    colname: "",
                    ruleID: "",
                    explain_txt: "",
                    explain_img: []
                };
            }
            if (this.setType == 2) {
                this.setItem.remarks = null;
                this.setItem.reg = 0;
                this.setItem.btnData = ["", ""];
                this.setItem.len = null;
                this.setItem.type = 4;

                this.setItem.explain_txt = "";
                this.setItem.explain_img = 4;
            }
        }
    }
};
</script>
<style scoped>
.upload {
    margin-bottom: 30px;
}
#wrapper {
    overflow: hidden;
    position: relative;
}
#wrapperChild {
    position: absolute;
}
.hd {
    background: #464c5b;
    color: #fff;
}
h3 {
    background: #dddee1;
    padding: 2px 5px 2px 20px;
    line-height: 30px;
    margin-top: -1px;
}
.mask_box {
    border-bottom: 1px solid #ddd;
}
.mod_btn {
    line-height: 40px;
}
.mod span {
    width: 80px;
    line-height: 40px;
}
.mod_btn button {
    margin: 5px 10px;
}
.inpBox {
    width: calc(100% - 80px);
}
.inpBox div {
    width: calc(100% - 20px);
}
.inpBox a {
    height: 30px;
    line-height: 30px;
}
.inpBox ul li {
    padding: 5px 0;
}
.xlsxLi {
    line-height: 30px;
    border-bottom: 1px dashed #464c5b;
    padding: 5px;
}
.batch {
    color: #fff;
}
</style>
<style>
.iScrollVerticalScrollbar {
    width: 10px !important;
}
.iScrollIndicator {
    border-radius: 10px !important;
    height: 100px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/template/mod/three.vue